import { useMutation } from '@tanstack/react-query';
import { get } from '../../utils/networking';

interface SlackOAuthInitiateResponse {
  authorizationUrl: string;
  state: string;
}

const initiateSlackOAuth = async (): Promise<SlackOAuthInitiateResponse> => {
  return get<SlackOAuthInitiateResponse>('/api/integrations/slack/auth/initiate');
};

export const useInitiateSlackOAuth = () => {
  return useMutation({
    mutationFn: initiateSlackOAuth,
  });
};
